/**
 * SEC-4: redirect the full page to a Stripe-hosted URL, but strip sensitive query
 * params (the `?token=` JWT and other deep-link params) from our URL FIRST, so
 * the token never lands in browser history or the `Referer` header sent to
 * Stripe. The strip MUST happen before the navigation — this helper enforces that
 * ordering in one place so it's unit-testable and can't be reordered by accident.
 *
 * `deps` is injectable for testing; in production it defaults to the real
 * history/location.
 */
export const stripSensitiveQueryParams = () => {
  if (typeof window !== "undefined" && window.history?.replaceState) {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};

/** Drop one query param from the address bar, keeping the rest. */
export const stripQueryParam = (name) => {
  if (typeof window === "undefined" || !window.history?.replaceState) {
    return;
  }
  const params = new URLSearchParams(window.location.search);
  params.delete(name);
  const query = params.toString();
  window.history.replaceState(
    {},
    document.title,
    `${window.location.pathname}${query ? `?${query}` : ""}`
  );
};

export const redirectToStripe = (
  url,
  { strip = stripSensitiveQueryParams, assign } = {}
) => {
  if (!url) {
    return false;
  }
  const go = assign || ((u) => window.location.assign(u));
  strip(); // must run before the navigation (SEC-4)
  go(url);
  return true;
};
